export default {
  acBlue: '#52A8EF',
  acOrange: '#FF765F',
  acGreen: '#B2E282',
  acGray: '#839FB7',
  acTurquoise: '#4DDCBD',
  acYellow: '#FAB830',
  acGold: '#FFA000',
  black: '#212121',
  charcoal: '#4a4a4a',
  nobel: '#979797',
  midGrayDark: '#747474',
  midGrayMedium: '#898989',
  midGray: '#a8a8a8',
  lightGray: '#E8E8E8',
  midGrayLight: '#d6d6d6',
  grayMedium: '#e1e1e1',
  grayLight: '#eeeeee',
  grayLightest: '#F7F8F9',
  offWhite: '#fbfbfb',
  offWhiteLight: '#fbfcfe',
  white: '#ffffff',
  red: '#FF0000',
};
